<template>
    <div>

        <div class="payVip" v-if="!!orderMoneyCoupon">
            <div class="topImg">
                <img :src="orderMoneyCoupon.picture" alt="" class="img" srcset="">
                <!-- <img src="../../assets/img/vip1.jpg" alt="" class="img" srcset=""> -->
            </div>
            <div class="">
                <div class="md-box">
                    <div class="md-title">
                        <p>{{ orderMoneyCoupon.activityName }}</p>
                        <p>{{ orderMoneyCoupon.title }}</p>
                    </div>
                    <div class="md-con">
                        <div style="display: flex;align-items: center; justify-content: center;">
                            <div>
                                团购数量：
                            </div>
                            <el-select v-model="selectedValue" @change="selectedChange" placeholder="请选择"
                                popper-class="custom-select-popper">
                                <el-option v-for="item in options" :key="item.id" :label="item.productCount"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="md-center">
                            <!-- <div class="md-orig">
                                <div class="pre">限时优惠</div>
                                <div class="pre-num">（ ￥{{ orderMoneyCoupon.price }} ）</div>
                            </div> -->
                            <div class="md-prc">
                                <div class="">价格：<span class="md-prc-rmb">￥ </span><span class="md-prc-num">{{
                                    orderMoneyCouponPrice }}</span><span class="md-prc-yuan">
                                        元</span></div>
                            </div>
                        </div>
                        <div class="md-tim">
                            <!-- <span class="pre">2023.06.01 - 2023.06.30</span> -->
                        </div>
                    </div>
                    <div class="buyBtn">

                        <el-button type="primary" @click="dialogFormVisible = true">立即购买</el-button>
                        <!-- <el-button type="primary" @click="cancelDingdan">微信支付</el-button> -->
                    </div>
                </div>
                <div class="md-bottom">
                    <!-- <div class="md-bottom-tit">
                        购买《第一财经》杂志 PRO会员·1年 包含
                    </div>
                    <div class="md-bottom-txt">
                        <div class="md-bottom-con">
                            <div class="dian">·</div>	<div class="text">全年12期杂志纸刊，包邮寄送（价值480元/年）</div>
                        </div>
                        <div class="md-bottom-con">
                            <div class="dian">·</div>	<div class="text">多平台数字杂志阅读权限、原创音频内容收听权限</div>
                        </div>
                        <div class="md-bottom-con">
                            <div class="dian">·</div>	<div class="text">8折购买《第一财经》杂志衍生实物产品</div>
                        </div>
                        <div class="md-bottom-con">
                            <div class="dian">·</div>	<div class="text">免费、优先参与《第一财经》杂志举办的各类活动</div>
                        </div>
                    </div>
                    <div class="md-bottom-tit">
                        活动优惠时间：2024年4月23日——4月30日
                    </div> -->
                    <div v-html="orderMoneyCoupon.activityBrief"></div>
                </div>
            </div>

            <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :center="true" class="loginBox">
                <div class="pwd-retrieve-container">
                    <el-form :model="user" label-width="1.2rem">
                        <el-form-item label="手机号">
                            <el-input v-model="user.mobile" autocomplete="off" maxlength="11"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码">
                            <el-input v-model="user.code" autocomplete="off">
                                <template slot="append">
                                    <el-button type="primary" @click="getCode()" v-if="!hasSend">获取验证码</el-button>
                                    <p class="resend" v-else>{{ second }}s 重新发送</p>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <Verify ref="verify" />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submit">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="qrcodeVisible" :center="true" class="qrcodeImg">
                <div style="text-align: center;">
                    <img class="image" src="../../assets/img/qrcode.png" alt="" srcset="">
                    <div class="text">1、请识别上方二维码进入《第一财经》杂志小程序。</div>
                    <div class="text">2、进入小程序后点击“我的”使用开通权限的手机号登录后即可阅读杂志&收听音频内容。</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import '@/api/rem.js'
import Verify from "@/components/verify.vue";
import { getFindPrice, getVerificationCode, login, payMent, getActivityList, payMentBatch } from "@/api/user.js";
//import { getMemberOrder ,cancelOrder} from "@/api/member.js";


export default {
    name: "promotion",
    components: {
        Verify
    },
    data() {
        return {
            orderMoneyCoupon: '',
            payId: 48,
            user: {
                mobile: '',
                code: '',
            },
            messageContent: '',
            successContent: '',
            hasSend: false,
            second: 60,
            dialogFormVisible: false,
            school: '',
            sendingCode: '',
            number: '',
            qrcodeVisible: false,

            selectedValue: null,
            options: [],
            orderMoneyCouponPrice: '',
            ladderId: null
        };
    },

    created() {
        // console.log(this.$route.query.activitySchool)
        // console.log(document.getElementById('app'))

        this.number = this.$route.query.id

        document.getElementById('app').style.minWidth = '7.5rem';
        document.getElementById('app').style.background = '#ffffff';
        document.getElementById('header').style.display = "none";
        document.getElementById('footer').style.display = "none";
        document.getElementById('fixed').style.display = "none";

        // if(this.$route.query.activitySchool == '1'){
        //     this.number = 1
        // }else if(this.$route.query.activitySchool == '2'){
        //     this.number = 2
        // }else if(this.$route.query.activitySchool == '3'){
        //     this.number = 3
        // }else if(this.$route.query.activitySchool == '4'){
        //     this.number = 4
        // }else if(this.$route.query.activitySchool == '5'){
        //     this.number = 5
        // }else if(this.$route.query.activitySchool == '6'){
        //     this.number = 6
        // }else if(this.$route.query.activitySchool == '7'){
        //     this.number = 7
        // }else if(this.$route.query.activitySchool == '8'){
        //     this.number = 8
        // }else if(this.$route.query.activitySchool == '9'){
        //     this.number = 9
        // }else if(this.$route.query.activitySchool == '10'){
        //     this.number = 10
        // }else if(this.$route.query.activitySchool == '11'){
        //     this.number = 11
        // }else if(this.$route.query.activitySchool == '12'){
        //     this.number = 12
        // }else if(this.$route.query.activitySchool == '13'){
        //     this.number = 13
        // }else if(this.$route.query.activitySchool == '14'){
        //     this.number = 14
        // }else if(this.$route.query.activitySchool == '15'){
        //     this.number = 15
        // }else if(this.$route.query.activitySchool == '16'){
        //     this.number = 16
        // }else{
        //     this.number = 0
        // }

        this.getData();
        this.getEmpower();



    },

    methods: {
        findById(array, idToFind) {
            return array.find(item => item.id === idToFind);
        },
        selectedChange(val) {
            // console.log(val)
            this.ladderId = val;
            const foundItem = this.findById(this.options, val);
            this.orderMoneyCouponPrice = foundItem.price;
        },

        getEmpower() {

            let codeData = this.$route.query.code;
            let stateData = this.$route.query.state;

            // console.log(codeData)
            // console.log(stateData)
            if (codeData != undefined) {
                this.sendingCode = codeData;
                this.school = stateData;
            } else {
                let url = 'https://www.cbnweek.com/batchBuy?id=' + this.number;
                // let url = 'http://test.shuzi110.com/batchBuy?id=' + this.number;
                let local = encodeURIComponent(url)
                window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + 'wx19f8d1085037ed93'
                        + "&redirect_uri=" + local
                        + "&state=" + this.number
                        + "&response_type=code&scope=snsapi_base#wechat_redirect"
            }

        },
        // 获取会员活动列表
        getData() {
            getActivityList({ id: this.number }).then(res => {
                // console.log(res.data)
                if (res.data.code == 500) {
                    this.$message({
                        message: '活动已结束',
                        type: 'warning',
                        duration: 10000,
                    });
                }
                else {
                    this.orderMoneyCoupon = res.data.data;
                    this.options = res.data.data.batchPurchaseActivityPriceLadders;
                }
                // console.log(this.orderMoneyCoupon)
            })
        },

        getCode() {
            if (this.user.mobile == '') {
                this.$message({
                    message: '请输入手机号',
                    type: 'warning',
                    duration: 1000,
                });
            } else {
                this.$refs.verify.showCaptcha().then(res => {
                    this.hasSend = true;
                    this.timeInterval = setInterval(() => {
                        if (this.second >= 1) {
                            this.second--;
                        } else {
                            this.hasSend = false;
                            this.second = 60;
                            clearInterval(this.timeInterval);
                        }
                    }, 1000)

                    var params = {
                        ...res,
                        login_name: this.user.mobile,
                        type: "0",
                    };
                    getVerificationCode(params).then(data => {
                        // console.log(data.data)
                        if (data.data.data.returncode == "0000") {
                            this.$message({
                                message: data.data.data.returnmsg,
                                type: 'success',
                                duration: 1000,
                            });

                        } else {
                            this.$message({
                                message: data.data.data.returnmsg,
                                type: 'warning',
                                duration: 1000,
                            });
                        }
                    })
                })
            }
        },
        submit() {
            if (this.user.mobile == '') {
                this.$message({
                    message: '手机号不能为空',
                    type: 'warning',
                    duration: 1000,
                });
            } else if (this.user.code == '') {
                this.$message({
                    message: '验证码不能为空',
                    type: 'warning',
                    duration: 1000,
                });
            } else {
                var params = {
                    code: this.user.code,
                    login_name: this.user.mobile,
                    activityType: '1',
                    activitySource: this.school,
                    empowerCode: this.sendingCode,
                };
                // console.log(params)
                login(params).then(res => {
                    // console.log(res.data)
                    if (res.data.code == 0) {

                        this.resetSetItem("isLogin", true);
                        this.resetSetItem("Authorization", res.data.data.token);
                        this.resetSetItem("userInfo", JSON.stringify(res.data.data));
                        this.dialogFormVisible = false;

                        const that = this;

                        var params = {

                            activityId: that.number,
                            ladderId: this.ladderId,
                            type: 0,
                            mobile: res.data.data.login_name,
                            userId: res.data.data.id,

                        };
                        // console.log(params)
                        payMentBatch(params).then(res => {
                            console.log(res);
                            if (res.data.code == 0) {

                                WeixinJSBridge.invoke('getBrandWCPayRequest', {
                                    "appId": res.data.data.appId,   //公众号ID，由商户传入    
                                    "timeStamp": res.data.data.timeStamp,   //时间戳，自1970年以来的秒数    
                                    "nonceStr": res.data.data.nonceStr,      //随机串    
                                    "package": res.data.data.packageValue,
                                    "signType": res.data.data.signType,     //微信签名方式：    
                                    "paySign": res.data.data.paySign //微信签名
                                },
                                    function (res) {
                                        // console.log(res)
                                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                                            // 使用以上方式判断前端返回,微信团队郑重提示：
                                            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                            that.qrcodeVisible = true;
                                        }

                                    });

                            } else {

                                that.$message({
                                    message: res.data.msg,
                                    type: 'warning',
                                    duration: 1000,
                                });

                            }
                        })





                    } else {
                        this.$message({
                            message: '登录失败',
                            type: 'warning',
                            duration: 1000,
                        });
                    }
                })
            }

        },

        cancelDingdan() {


            var params = {
                productId: 3,
                type: 0,
                mobile: '18230376690',
                userId: '605207'
            };
            // console.log(params)
            payMent(params).then(res => {
                console.log(res.data.code)
                if (res.data.code == 200) {
                    WeixinJSBridge.invoke('getBrandWCPayRequest', {
                        "appId": res.data.data.appId,   //公众号ID，由商户传入    
                        "timeStamp": res.data.data.timeStamp,   //时间戳，自1970年以来的秒数    
                        "nonceStr": res.data.data.nonceStr,      //随机串    
                        "package": res.data.data.packageValue,
                        "signType": res.data.data.signType,     //微信签名方式：    
                        "paySign": res.data.data.paySign //微信签名
                    },
                        function (res) {
                            // console.log(res)
                            if (res.err_msg == "get_brand_wcpay_request:ok") {
                                // 使用以上方式判断前端返回,微信团队郑重提示：
                                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {

                            } else {

                            }
                        });
                } else {

                    this.$message({
                        message: res.data.msg,
                        type: 'warning',
                        duration: 1000,
                    });

                }

            })




        }

    },

};


</script>

<style lang="scss" scoped>
.payVip {
    font-family: "Microsoft YaHei", "SimHei", "Helvetica", "Arial", "Tahoma", "sans-serif";
    font-style: normal;
    text-align: center;

    .topImg {
        .img {
            width: 7.5rem;
            height: 3.9rem;
            border-radius: .1rem;
        }
    }

    .md-box {
        width: 6.9rem;
        box-shadow: .02rem .2rem .2rem rgba(102, 62, 51, 0.02), -6px 10px 20px rgba(102, 62, 51, 0.04);
        border-radius: .1rem;
        margin: .48rem auto;
        padding: .32rem 0;
    }

    .md-title {
        font-size: .32rem;
        text-align: center;
        font-weight: 600;
        color: #000000;
        line-height: .44rem;
    }

    .md-con {
        margin: .36rem 0 .32rem 0;
        position: relative;
        text-align: center;

        .md-center {
            display: flex;
            justify-content: center;
            align-items: center;

            .md-orig {
                padding: 0 .1rem;

                .pre {
                    color: #FF7900;
                    font-size: .24rem;
                    margin-bottom: .1rem;
                }

                .pre-num {
                    font-size: .28rem;
                    text-decoration: line-through;
                    color: #C8C8C8;
                }
            }

            .md-prc {
                color: #000000;

                .md-prc-rmb {
                    font-weight: 400;
                    font-size: .4rem;
                }

                .md-prc-num {
                    font-weight: 600;
                    font-size: .68rem;
                }

                .md-prc-yuan {
                    font-weight: 600;
                    font-size: .32rem;
                }
            }
        }

        .md-tim {
            font-size: .28rem;
            color: #969696;
            padding: .2rem 0;
        }

    }

    .md-bottom {
        width: 6.4rem;
        margin: 0 auto;
        padding: 0 0 1rem 0;

        .md-bottom-tit {
            font-weight: 600;
            font-size: .3rem;
            color: #000000;
            text-align: left;
        }

        .md-bottom-txt {
            padding-bottom: .6rem;

            .md-bottom-con {
                display: flex;
                align-items: center;
                margin-top: .2rem;
            }

            .dian {
                font-size: .6rem;
                padding: 0 .2rem;
                line-height: .3rem;
            }

            .text {
                font-weight: 400;
                font-size: .26rem;
                line-height: .3rem;
                color: #000000;
            }

            .text-tip {
                font-size: .24rem;
                line-height: .3rem;
                text-align: justify;
                text-transform: capitalize;
                color: #969696;
            }
        }
    }

    .buyBtn {
        // padding:20rpx 0;
        display: flex;
        justify-content: center;

        button {
            width: 2.18rem;
            height: .88rem;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: .28rem;
            color: #ffffff;
            margin: 0;
        }

        .shareBtn {
            background: #8C6C0E;
            color: #ffffff;
            margin-right: .2rem;
        }

    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }



}




>>>.loginBox .el-dialog {
    width: 6.8rem;
    border-radius: .1rem;
    margin-top: 50% !important;
}

>>>.loginBox .dialog-footer .el-button {
    width: 100%;
    padding: .26rem .24rem;
    font-size: .28rem;
}

>>>.loginBox .el-dialog__header {
    padding: 0;
}

>>>.loginBox .el-dialog__body {
    padding: .5rem .3rem 0 .3rem;
}

>>>.loginBox .el-form-item__label {
    font-size: .28rem;
    padding: 0 .24rem 0 0;
}

>>>.loginBox .el-input__inner {
    height: .8rem;
    line-height: .8rem;
    padding: 0 0.2rem;
}

>>>.qrcodeImg .el-dialog {
    width: 6rem;
    border-radius: .1rem;

}

>>>.qrcodeImg .el-dialog .image {
    width: 4.2rem;
}

>>>.qrcodeImg .el-dialog__body {
    text-align: center;
}

>>>.qrcodeImg .el-dialog__body .text {
    text-align: initial;
}

>>>.qrcodeImg .el-dialog__headerbtn {
    top: .2rem;
    right: .2rem;
    font-size: .5rem;
}


.custom-select-popper .el-input {
    padding-right: 0 !important;
    /* 移除输入框后的图标 */
    background-color: #fff !important;
    /* 修改下拉菜单背景色 */
}
</style>
<style>
.el-scrollbar .el-scrollbar__bar {
    opacity: 1 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/promotion/batchBuy.vue